<app-certificate *ngIf="showModel" [certificateInfo]="certificateInfo" (closeCertificateEvent)="closeCertificateEvent($event)"></app-certificate>
<input type="button" id="btnShowModel" class="d-none" data-bs-toggle="modal" data-bs-target="#modelCertificate"
    data-bs-whatever="@mdo">